export default __webpack_public_path__ + "static/media/Squre2.071fcf00.svg";